export default __webpack_public_path__ + "static/media/Kannada_em_2.e0a1598c.mp3";